import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";

const ConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  title,
  confirmLabel = "Confirm",
  confirmVariant = "danger",
  isLoading = false,
  loadingLabel = null,
  staticWhileLoading = false,
  className = "",
  children,
}) => {
  const isStatic = staticWhileLoading && isLoading;

  return (
    <Modal
      show={show}
      onHide={isStatic ? undefined : onHide}
      centered
      backdrop={isStatic ? "static" : true}
      keyboard={!isStatic}
      className={className}
    >
      <Modal.Body className="pt-0 pb-2">
        <Modal.Header className="modal-title-with-border mb-0" closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 pb-2">{children}</Modal.Body>
        <Modal.Footer className="mt-3">
          <Button
            variant="outline-secondary"
            onClick={isStatic ? undefined : onHide}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant={confirmVariant}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              loadingLabel ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  {loadingLabel}
                </>
              ) : (
                <Spinner animation="border" size="sm" />
              )
            ) : (
              confirmLabel
            )}
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmationModal;
